import { useState } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function Servicos() {
  const [selectedCategory, setSelectedCategory] = useState('todos');

  const categories = [
    { id: 'todos', label: 'Todos os serviços' },
    { id: 'consultoria', label: 'Consultoria Estratégica' },
    { id: 'marketing', label: 'Marketing e Comunicação' },
    { id: 'treinamento', label: 'Formação' },
    { id: 'gestao', label: 'Gestão de Projectos' },
    { id: 'eventos', label: 'Eventos e Iniciativas' },
  ];

  const services = [
    {
      category: 'consultoria',
      icon: 'ri-lightbulb-line',
      title: 'Consultoria Estratégica Estratégica',
      description: 'Apoiamos organizações na definição e implementação de estratégias sustentáveis e de desenvolvimento institucional, através de análises aprofundadas, planeamento estratégico e soluções adaptadas à realidade de cada organização.',
      features: ['Planeamento estratégico e institucional', 'Estratégias de sustentabilidade e ESG', 'Análise de riscos e oportunidades', 'Apoio à tomada de decisão', 'Modelos de governação e desempenho'],
      image: 'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/ce7af9b46b121e5de4aed423ce04f11e.jpeg',
    },
    {
      category: 'marketing',
      icon: 'ri-megaphone-line',
      title: 'Marketing e Comunicação',
      description: 'Desenvolvemos estratégias de marketing e comunicação corporativa alinhadas ao posicionamento institucional, reforçando reputação, visibilidade e coerência entre discurso e prática.',
      features: ['Estratégia de comunicação institucional', 'Posicionamento e branding corporativo', 'Comunicação de impacto e sustentabilidade', 'Marketing estratégico e conteúdos', 'Gestão de imagem e reputação'],
      image: 'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/c9b859d6b8e7ab96d2a9087c0ab69c22.jpeg',
    },
    {
      category: 'treinamento',
      icon: 'ri-team-line',
      title: 'Formação e Capacitação',
      description: 'Concebemos e implementamos programas de formação e capacitação técnica e executiva, orientados para o desenvolvimento de competências, liderança e implementação eficaz de estratégias organizacionais.',
      features: ['Sustentabilidade e ESG', 'Liderança e gestão', 'Capacitação empresarial', 'Desenvolvimento organizacional', 'Formação personalizada por sector'],
      image: 'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/937592926c0c5b52d8a9134b8f8e5648.jpeg',
    },
    {
      category: 'gestao',
      icon: 'ri-file-list-3-line',
      title: 'Gestão de Projectos',
      description: 'Asseguramos a gestão integrada de projectos estratégicos, desde a concepção até à execução, garantindo eficiência, cumprimento de prazos e alinhamento com os objectivos institucionais.',
      features: ['Metodologias ágeis', 'Gestão de riscos', 'Controlo de qualidade', 'Relatórios detalhados'],
      image: './post/img7.png',
    },
    {
      category: 'eventos',
      icon: 'ri-calendar-event-line',
      title: 'Eventos e Iniciativas',
      description: 'Planeamos, organizamos e gerimos eventos corporativos, fóruns e iniciativas institucionais.',
      features: ['Planeamento completo', 'Gestão de fornecedores', 'Coordenação logística', 'Suporte no dia'],
      image: 'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/ab3e18b0d36f3cec6fe6b4b89e096201.jpeg',
    },
    {
      category: 'consultoria',
      icon: 'ri-line-chart-line',
      title: 'Análise de Desempenho',
      description: 'Realizamos análises de desempenho organizacional e de projectos, utilizando indicadores estratégicos e métricas de impacto para apoiar a melhoria contínua e a tomada de decisão.',
      features: ['KPIs personalizados', 'Dashboards interactivos', 'Análise comparativa', 'Recomendações práticas'],
      image: 'https://readdy.ai/api/search-image?query=Business%20analytics%20dashboard%20displaying%20performance%20metrics%20and%20data%20visualization%20on%20modern%20screens%2C%20professional%20data%20analysis%20environment%20with%20charts%20and%20graphs%2C%20clean%20minimalist%20office%20setting%20with%20soft%20lighting&width=800&height=600&seq=serv5&orientation=landscape',
    },
    {
      category: 'treinamento',
      icon: 'ri-user-star-line',
      title: 'Desenvolvimento de Liderança',
      description: 'Desenvolvemos programas orientados para o fortalecimento da liderança e da cultura organizacional, promovendo equipas mais eficazes, alinhadas e preparadas para os desafios actuais.',
      features: ['Programas de liderança estratégica', 'Desenvolvimento de competências de gestão', 'Fortalecimento da cultura organizacional'],
      image: 'https://static.readdy.ai/image/99a26e87477a80c464cb53cf64d61165/f449f65e8da2dc7621000ca5270dec61.jpeg',
    },
  ];

  const filteredServices = selectedCategory === 'todos' 
    ? services 
    : services.filter(service => service.category === selectedCategory);

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#CB9832]/5 via-white to-[#CB9832]/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <nav className="text-sm text-gray-600 mb-6">
            <a href="/" className="hover:text-[#CB9832] cursor-pointer">Início</a>
            <span className="mx-2">&gt;</span>
            <span className="text-[#CB9832]">SERVIÇOS</span>
          </nav>
          <h1 className="text-3xl md:text-5xl font-bold text-black mb-6">OS NOSSOS SERVIÇOS</h1>
           {/*<p className="text-lg md:text-lg text-gray-700 max-w-4xl mx-auto leading-relaxed">
            Soluções estratégicas, integradas e personalizadas para apoiar o crescimento sustentável, a eficiência organizacional e a geração de valor a longo prazo.
          </p>*/}
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-12 bg-white border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap ${
                  selectedCategory === category.id
                    ? 'bg-[#2D5F3F] text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredServices.map((service, index) => (
              <div key={index} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all group">
                <div className="relative h-56 overflow-hidden">
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute top-4 right-4 w-14 h-14 flex items-center justify-center bg-[#CB9832] rounded-full shadow-lg">
                    <i className={`${service.icon} text-2xl text-white`}></i>
                  </div>
                </div>

                <div className="p-6">
                  <h3 className="text-2xl font-bold text-black mb-3">{service.title}</h3>
                  <p className="text-gray-600 mb-4 leading-relaxed">{service.description}</p>

                  <div className="space-y-2 mb-6">
                    {service.features.map((feature, idx) => (
                      <div key={idx} className="flex items-center gap-2">
                        <i className="ri-checkbox-circle-fill text-[#CB9832]"></i>
                        <span className="text-sm text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>

                  <Link
                    to="/contato"
                    className="inline-flex items-center bg-[#2D5F3F] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#234A32] transition-all whitespace-nowrap cursor-pointer"
                  >
                    Saber Mais
                    <i className="ri-arrow-right-line ml-2"></i>
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-10 bg-[#F8F8F8]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-black mb-4">Porquê Escolher a +KUDIMA?</h2>
            {/*<p className="text-xl text-gray-700 max-w-3xl mx-auto">
              Experiência comprovada e compromisso com resultados sustentáveis.
            </p>*/}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              {
                icon: 'ri-award-line',
                title: 'Experiência Comprovada',
                
              },
              {
                icon: 'ri-team-line',
                title: 'Equipa Especializada',
               
              },
              {
                icon: 'ri-customer-service-2-line',
                title: 'Suporte Contínuo',
                
              },
              {
                icon: 'ri-line-chart-line',
                title: 'Resultados Mensuráveis',
                
              },
            ].map((item, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 text-center hover:shadow-xl transition-all group cursor-pointer">
                <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center bg-[#2D5F3F] rounded-full group-hover:scale-110 transition-transform">
                  <i className={`${item.icon} text-3xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-black mb-3">{item.title}</h3>
                <p className="text-gray-600 leading-relaxed">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-10 bg-gradient-to-br from-[#CB9832] to-[#B8872D]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Pronto para Transformar o Seu Negócio?
          </h2>
          {/*<p className="text-lg text-white/90 mb-8 leading-relaxed">
            Entre em contacto connosco e descubra como a +KUDIMA pode apoiar a sua organização na implementação de soluções estratégicas com impacto mensurável.
          </p>*/}
          <Link
            to="/contato"
            className="inline-flex items-center bg-[#2D5F3F] text-white px-8 py-4 rounded-full font-semibold text-lg hover:bg-[#234A32] transition-all shadow-xl whitespace-nowrap cursor-pointer"
          >
            Fale com a Nossa Equipa
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </section>

      <Footer />
    </div>
  );
}
